import axios from 'axios';
import apiRequestHeaders from '../apiRequestHeaders';
import {
  AddonServiceRuleItemsData,
  LastMinuteRuleDetails,
  MinimumLengthOfStayRuleDetails,
  PreparationRestrictionRuleDetails,
  PriceChangeRuleDetails,
  ReleaseIntervalRuleDetails,
  ShortStayRuleDetails,
  WeekdayCheckInAndCheckOutTimeItemsData,
  WeekdayCheckInRuleItem,
  WeekdayCheckOutRuleItem,
  WeekdayMinimumStayRuleItemsData,
  WeekdayPriceChangeRuleItemsData,
} from '../types/rates.types';
import axiosInstance from './axiosInstance';

export function fetchWeekdayCheckInRulesByDefaultRateId(defaultRateId: string) {
  const config = {
    headers: {
      ...apiRequestHeaders.csrfHeader(),
      ...apiRequestHeaders.activeSiteHeader(),
    },
    params: { defaultRateId },
  };

  return axios
    .get('/pricing/rateRules/getWeekdayCheckInRulesByDefaultRateId', config)
    .then(res => res.data);
}

export function fetchWeekdayCheckOutRulesByDefaultRateId(
  defaultRateId: string,
) {
  const config = {
    headers: {
      ...apiRequestHeaders.csrfHeader(),
      ...apiRequestHeaders.activeSiteHeader(),
    },
    params: { defaultRateId },
  };

  return axios
    .get('/pricing/rateRules/getWeekdayCheckOutRulesByDefaultRateId', config)
    .then(res => res.data);
}

export function updateDefaultRateWeekdayCheckInAndCheckOutRules(
  defaultRateId: string,
  weekdayCheckInRuleData: WeekdayCheckInRuleItem[],
  weekdayCheckOutRuleData: WeekdayCheckOutRuleItem[],
) {
  const config = {
    headers: {
      ...apiRequestHeaders.csrfHeader(),
      ...apiRequestHeaders.activeSiteHeader(),
    },
  };

  const requestData = {
    defaultRateId,
    blockedCheckInWeekdays: weekdayCheckInRuleData,
    blockedCheckOutWeekdays: weekdayCheckOutRuleData,
  };

  return axios
    .put(
      '/pricing/rateRules/updateDefaultRateWeekdayCheckInAndCheckOutRules',
      requestData,
      config,
    )
    .then(res => res.data);
}

export function fetchMinimumLengthOfStayRuleByDefaultRateId(
  defaultRateId: string,
) {
  const config = {
    headers: {
      ...apiRequestHeaders.csrfHeader(),
      ...apiRequestHeaders.activeSiteHeader(),
    },
    params: { defaultRateId },
  };

  return axios
    .get('/pricing/rateRules/getMinimumLengthOfStayRuleByDefaultRateId', config)
    .then(res => res.data);
}

export function updateDefaultRateMinimumLengthOfStayRule(
  minimumLengthOfStayRuleData: MinimumLengthOfStayRuleDetails,
) {
  const config = {
    headers: {
      ...apiRequestHeaders.csrfHeader(),
      ...apiRequestHeaders.activeSiteHeader(),
    },
  };

  return axios
    .put(
      '/pricing/rateRules/updateDefaultRateMinimumLengthOfStayRule',
      minimumLengthOfStayRuleData,
      config,
    )
    .then(res => res.data);
}

export function fetchPreparationRestrictionRuleByDefaultRateId(
  defaultRateId: string,
) {
  const config = {
    headers: {
      ...apiRequestHeaders.csrfHeader(),
      ...apiRequestHeaders.activeSiteHeader(),
    },
    params: { defaultRateId },
  };

  return axios
    .get(
      '/pricing/rateRules/getPreparationRestrictionRuleByDefaultRateId',
      config,
    )
    .then(res => res.data);
}

export function updateDefaultRatePreparationRestrictionRule(
  preparationRestrictionRuleData: PreparationRestrictionRuleDetails,
) {
  const config = {
    headers: {
      ...apiRequestHeaders.csrfHeader(),
      ...apiRequestHeaders.activeSiteHeader(),
    },
  };

  return axios
    .put(
      '/pricing/rateRules/updateDefaultRatePreparationRestrictionRule',
      preparationRestrictionRuleData,
      config,
    )
    .then(res => res.data);
}

export function fetchShortStayRuleByDefaultRateId(defaultRateId: string) {
  const config = {
    headers: {
      ...apiRequestHeaders.csrfHeader(),
      ...apiRequestHeaders.activeSiteHeader(),
    },
    params: { defaultRateId },
  };

  return axios
    .get('/pricing/rateRules/getShortStayRuleByDefaultRateId', config)
    .then(res => res.data);
}

export function updateDefaultRateShortStayRule(
  shortStayRuleData: ShortStayRuleDetails,
) {
  const config = {
    headers: {
      ...apiRequestHeaders.csrfHeader(),
      ...apiRequestHeaders.activeSiteHeader(),
    },
  };

  return axios
    .put(
      '/pricing/rateRules/updateDefaultRateShortStayRule',
      shortStayRuleData,
      config,
    )
    .then(res => res.data);
}

export function fetchLastMinuteRuleByDefaultRateId(defaultRateId: string) {
  const config = {
    headers: {
      ...apiRequestHeaders.csrfHeader(),
      ...apiRequestHeaders.activeSiteHeader(),
    },
    params: { defaultRateId },
  };

  return axios
    .get('/pricing/rateRules/getLastMinuteRuleByDefaultRateId', config)
    .then(res => res.data);
}

export function updateDefaultRateLastMinuteRule(
  lastMinuteRuleData: LastMinuteRuleDetails,
) {
  const config = {
    headers: {
      ...apiRequestHeaders.csrfHeader(),
      ...apiRequestHeaders.activeSiteHeader(),
    },
  };

  return axios
    .put(
      '/pricing/rateRules/updateDefaultRateLastMinuteRule',
      lastMinuteRuleData,
      config,
    )
    .then(res => res.data);
}

export function fetchPriceChangeRuleByDefaultRateId(defaultRateId: string) {
  const config = {
    headers: {
      ...apiRequestHeaders.csrfHeader(),
      ...apiRequestHeaders.activeSiteHeader(),
    },
    params: { defaultRateId },
  };

  return axios
    .get('/pricing/rateRules/getPriceChangeRuleByDefaultRateId', config)
    .then(res => res.data);
}

export function updateDefaultRatePriceChangeRule(
  priceChangeRuleData: PriceChangeRuleDetails,
) {
  const config = {
    headers: {
      ...apiRequestHeaders.csrfHeader(),
      ...apiRequestHeaders.activeSiteHeader(),
    },
  };

  return axios
    .put(
      '/pricing/rateRules/updateDefaultRatePriceChangeRule',
      priceChangeRuleData,
      config,
    )
    .then(res => res.data);
}

export function fetchReleaseIntervalRuleByDefaultRateId(defaultRateId: string) {
  const config = {
    params: { defaultRateId },
  };

  return axiosInstance
    .get('/pricing/rateRules/getReleaseIntervalRuleByDefaultRateId', config)
    .then(res => res.data);
}

export function updateDefaultRateReleaseIntervalRule(
  releaseIntervalRuleData: ReleaseIntervalRuleDetails,
) {
  const config = {
    headers: {
      ...apiRequestHeaders.csrfHeader(),
      ...apiRequestHeaders.activeSiteHeader(),
    },
  };

  return axios
    .put(
      '/pricing/rateRules/updateDefaultRateReleaseIntervalRule',
      releaseIntervalRuleData,
      config,
    )
    .then(res => res.data);
}

export function fetchWeekdayMinimumStayRulesDataByDefaultRateId(
  defaultRateId: string,
) {
  const config = {
    headers: {
      ...apiRequestHeaders.csrfHeader(),
      ...apiRequestHeaders.activeSiteHeader(),
    },
    params: { defaultRateId },
  };

  return axios
    .get('/pricing/rateRules/getWeekdayMinimumStayRulesByDefaultRateId', config)
    .then(res => res.data);
}

export function updateDefaultRateWeekdayMinimumStayRulesData(
  weekdayMinimumStayRuleData: WeekdayMinimumStayRuleItemsData,
) {
  const config = {
    headers: {
      ...apiRequestHeaders.csrfHeader(),
      ...apiRequestHeaders.activeSiteHeader(),
    },
  };

  return axios
    .put(
      '/pricing/rateRules/updateDefaultRateWeekdayMinimumStayRules',
      weekdayMinimumStayRuleData,
      config,
    )
    .then(res => res.data);
}

export function fetchWeekdayPriceChangeRulesDataByDefaultRateId(
  defaultRateId: string,
) {
  const config = {
    headers: {
      ...apiRequestHeaders.csrfHeader(),
      ...apiRequestHeaders.activeSiteHeader(),
    },
    params: { defaultRateId },
  };

  return axios
    .get('/pricing/rateRules/getWeekdayPriceChangeRulesByDefaultRateId', config)
    .then(res => res.data);
}

export function updateDefaultRateWeekdayPriceChangeRulesData(
  weekdayPriceChangeRuleData: WeekdayPriceChangeRuleItemsData,
) {
  const config = {
    headers: {
      ...apiRequestHeaders.csrfHeader(),
      ...apiRequestHeaders.activeSiteHeader(),
    },
  };

  return axios
    .put(
      '/pricing/rateRules/updateDefaultRateWeekdayPriceChangeRules',
      weekdayPriceChangeRuleData,
      config,
    )
    .then(res => res.data);
}

export function fetchWeekdayCheckInAndCheckOutTimesDataByDefaultRateId(
  defaultRateId: string,
) {
  const config = {
    headers: {
      ...apiRequestHeaders.csrfHeader(),
      ...apiRequestHeaders.activeSiteHeader(),
    },
    params: { defaultRateId },
  };

  return axios
    .get(
      '/pricing/rateRules/getWeekdayCheckInCheckOutTimesByDefaultRateId',
      config,
    )
    .then(res => res.data);
}

export function updateDefaultRateWeekdayCheckInAndCheckOutTimesData(
  weekdayCheckInAndCheckOutTimesData: WeekdayCheckInAndCheckOutTimeItemsData,
) {
  const config = {
    headers: {
      ...apiRequestHeaders.csrfHeader(),
      ...apiRequestHeaders.activeSiteHeader(),
    },
  };
  return axios
    .put(
      '/pricing/rateRules/updateDefaultRateWeekdayCheckInCheckOutTimes',
      weekdayCheckInAndCheckOutTimesData,
      config,
    )
    .then(res => res.data);
}

export function fetchAdditionalServiceRulesDataByDefaultRateId(
  defaultRateId: string,
  accommodationId: string,
) {
  const config = {
    headers: {
      ...apiRequestHeaders.csrfHeader(),
      ...apiRequestHeaders.activeSiteHeader(),
    },
    params: { defaultRateId, accommodationId },
  };

  return axios
    .get('/pricing/rateRules/getAdditionalServiceRulesByDefaultRateId', config)
    .then(res => res.data);
}

export function updateDefaultRateAdditionalServiceRules(
  addonServiceRuleItemsData: AddonServiceRuleItemsData,
) {
  const config = {
    headers: {
      ...apiRequestHeaders.csrfHeader(),
      ...apiRequestHeaders.activeSiteHeader(),
    },
  };

  return axios
    .put(
      '/pricing/rateRules/updateDefaultRateAdditionalServiceRule',
      addonServiceRuleItemsData,
      config,
    )
    .then(res => res.data);
}
